import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import indexRoutes from "routes/index.jsx";
import "assets/scss/material-kit-react.css?v=1.3.0";
import "assets/css/MyCssFile.css"
import Footer from "components/Footer/Footer.jsx";
import TopMadoule from "./components/TopBanner/TopMadoule";

import thunk from 'redux-thunk';
import reducer from './redux/reducers';
import { routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware } from 'redux';
import { loadState, saveState } from './custom/localstorage';
import { Provider } from 'react-redux';



var hist = createBrowserHistory();
const middleware = [thunk];
// middleware.push(createLogger());
middleware.push(routerMiddleware(hist))
const persistedState = loadState();
const store = createStore(
  reducer,
  persistedState,
  applyMiddleware(...middleware)

);
store.subscribe(() => {
  saveState(store.getState());
});



ReactDOM.render(
  <Provider store={store}>
  <Router history={hist}>
    <div>
      <TopMadoule />
      {/* <Header
        brand="سامانه فروش قراضه سبا"
        rightLinks={<HeaderLinks />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 0,
          color: "white"
        }}
        {...rest}
      /> */}
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <Route path={prop.path} key={key} component={prop.component} exact />;
        })}
      </Switch>
      <Footer />
    </div>
  </Router>,
  </Provider>,
  document.getElementById("root")
);
